import {formatCurrency, formatTons, formatMW, formatMWh} from '@hconnect/uikit/src/common'
import {useDisplayPlantCurrency} from '@widgets/planning-schedule-chart'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

export type KPIUnit = 'currency' | 'tons' | 'mwh' | 'mw'

export function useKPIValueFormatter() {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)
  const displayCurrency = useDisplayPlantCurrency()

  return useCallback(
    (amount: number, unit: KPIUnit, {digits}: {digits?: number} = {}) => {
      if (unit === 'tons') return formatTons(amount, language, t('common.unit.t'))
      if (unit === 'mwh') return formatMWh(amount, language, t('common.unit.MWh'))
      if (unit === 'mw') return formatMW(amount, language, t('common.unit.MW'))
      return t('common.amountInCurrency', {
        amount: formatCurrency(amount, digits ?? 0, language),
        currency: displayCurrency
      })
    },
    [t, language, displayCurrency]
  )
}
